module.exports = __webpack_public_path__ + "img/contract.a96ed723.svg";